export enum AssetDestructionType {
Destructed,
Lost,
Stolen,
}
